import Vue from 'vue';
import router from '@/router';
import Vant from 'vant';
import App from './App.vue';
// 引入store
import store from './store';
// 引入router
import 'vant/lib/index.css';

Vue.use(Vant);
// treeselect();

// 注册全局组件
// Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  store,
  router,
}).$mount('#app');
